import React from "react";
const EvolvedSettingsPersonalizePage = React.memo(({ personalizationFeedProvider }) => {
    // TODO https://task.ms/45393486: need style here
    return (React.createElement("iframe", { src: personalizationFeedProvider === null || personalizationFeedProvider === void 0 ? void 0 : personalizationFeedProvider.settingsUri, name: personalizationFeedProvider === null || personalizationFeedProvider === void 0 ? void 0 : personalizationFeedProvider.id, style: { "height": "100vh" } }));
});
export default EvolvedSettingsPersonalizePage;
